const { default: axiosIns } = require('@/libs/axios')

const LandingService = {
  // GET - LandingApiController
  async getLanding() {
    return axiosIns.get('/landing').then(response => response.data)
  },
}

export default LandingService
